import React, { useState } from 'react'
import StateComponents from '../../../../components/state-component/StateComponents'
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Drawer, IconButton, Paper, Stack, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { IconComponent } from '../../../../assets/icons/icons';
import { ManageState } from './manageState';
import { BoxContentRendering } from './component/BoxContent';
import PieChart from '../../complaint/charts/PieChart';
import HorizontalChart from '../../complaint/charts/HorizontalChart';
import TableCustom from '../../../../components/table/tableCustom';

import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../../routes/routeName';
import ContainerButton from '../../../../components/button/ContainerButton';

import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import StatusCustom from '../../../../components/status/statusCustom';
import CustomPagination from '../../../../components/pagination/PaginationCustom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import moment from 'moment';
import { debouncedApiCall, formatBudget } from '../../../../utils/app.utils';
import { ed_pex_department_responsible, ed_pex_project_status_data } from '../enum/enum';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

type Props = {}

const BoxColorCustom = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'bgcolor'
})<{ bgcolor?: string }>(({ bgcolor }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: "14px 16px",
    gap: 2,
    borderRadius: '16px',
    alignItems: 'flex-start',
    backgroundColor: bgcolor || "#E3FBFF",
    width: "100%",
    maxWidth: 140
}))
const EdPexDisplayPage: React.FC<Props> = ({ }: Props) => {
    const {
        page,
        pageLimit,
        sortBy,
        sortType,
        data,
        totalItems,
        setPage,
        setPageLimit,
        headCells,
        renderData,
        handleRequestSort,
        step,
        setStep,
        headCellAll,
        headCellAllNext,
        dataMini,
        setSearch,
        handleExportReportData,
        year_data,
        filterData,
        start_year,
        set_start_year,
        end_year,
        set_end_year,
        ed_pex_status,
        set_ed_pex_status,
        filterId,
        setFilterId,
        handleGetDataMini,
        pageEdPex,
        setPageEdPex,
        setPageLimitEdPex,
        pageLimitEdPex,
        search,
        department_responsible,
        set_department_responsible,
        totalItemsEdPex,
        setSearchEdPex,
        start_year_ed_pex,
        set_start_year_ed_pex,
        status_ed_pex_data,
        set_status_ed_pex_data,
        set_department_responsible_ed_pex,
        department_responsible_ed_pex,
        standard_point_data,
        id_edpex_standard_point,
        set_id_edpex_standard_point,
        handleFindDetailProject,
        detailProject,
        pageDetail,
        setPageDetail
    } = ManageState();


    const [groupedMonths, _setGroupedMonths] = useState<{ year: number, months: { key: number, month: string }[] }[]>([
        {
            year: moment().add(543, 'year').year(),
            months: [
                { key: 10, month: 'ต.ค' },
                { key: 11, month: 'พ.ย' },
                { key: 12, month: 'ธ.ค' }]
        },
        {
            year: moment().add(543, 'year').add(1, 'year').year(),
            months: [
                { key: 1, month: 'ม.ค' },
                { key: 2, month: 'ก.พ' },
                { key: 3, month: 'มี.ค' },
                { key: 4, month: 'เม.ย' },
                { key: 5, month: 'พ.ค' },
                { key: 6, month: 'มิ.ย' },
                { key: 7, month: 'ก.ค' },
                { key: 8, month: 'ส.ค' },
                { key: 9, month: 'ก.ย' },
            ]
        },
    ])
    const [openDetail, setOpenDetail] = useState<{ status: boolean, id: number | null, full_width: boolean }>({
        id: null,
        status: false,
        full_width: false
    })
    function renderBarCells(
        totalMonths: number,
        barSpans: { start: number; length: number; active: boolean }[],
        end_date: string,
        list_data: any
    ) {
        const cells: JSX.Element[] = [];
        let currentIndex = 0;
        const customMonthOrder = [9, 10, 11, 0, 1, 2, 3, 4, 5, 6, 7, 8]; // ต.ค → ก.ย
        const toCustomIndex = (month: number) =>
            customMonthOrder.findIndex((m) => m === month);

        const endMoment = moment(end_date);
        const startMoment = moment(list_data?.edpex_project_start_date);
        const startMonth = startMoment.month(); // เดือนที่เริ่ม (0-11)

        const projectStartMonth = moment(list_data?.edpex_project_start_date).month(); // เช่น 10 (พ.ย.)
        const projectStartIndex = toCustomIndex(projectStartMonth);

        const startMonthIndex = toCustomIndex(startMonth); // แปลงเป็น custom index
        const endMonth = endMoment.month(); // 0-11
        const endDay = endMoment.date();
        const daysInMonth = endMoment.daysInMonth();
        const percentOfMonth = (endDay / daysInMonth) * 100;

        const endMonthIndex = toCustomIndex(endMonth); // ใช้เทียบใน custom index

        // คำนวณตำแหน่งแม่นยำรวมวันที่ (เป็นทศนิยม)
        const exactEndPosition = endMonthIndex + (endDay / daysInMonth);

        // เพิ่มช่องว่างก่อนเดือนเริ่มต้นของโปรเจกต์
        if (projectStartIndex > 0) {
            for (let i = 0; i < projectStartIndex; i++) {
                const adjustedIndex = i; // index ที่แท้จริงในตาราง
                cells.push(
                    <TableCell
                        key={`empty-start-${i}`}
                        sx={{
                            borderLeft: adjustedIndex >= exactEndPosition ? "1px solid #DDE1EB" : "none",
                            padding: 0,
                            px: 2,
                            py: 2,
                        }}
                    />
                );
                currentIndex++;
            }
        }

        for (const bar of barSpans) {
            // ช่องว่างก่อนแถบ (ปรับให้คิดจาก currentIndex ที่มีช่องว่างแล้ว)
            if (bar.start > currentIndex) {
                for (let i = currentIndex; i < bar.start; i++) {
                    const adjustedIndex = i; // index ที่แท้จริงในตาราง
                    cells.push(
                        <TableCell
                            key={`gap-${i}`}
                            sx={{
                                borderLeft: adjustedIndex >= endMonthIndex ? "1px solid #DDE1EB" : "none",
                                padding: 0,
                                px: 2,
                                py: 2,
                            }}
                        />
                    );
                }
            }

            // แถบสี
            for (let i = 0; i < bar.length; i++) {
                const colIndex = bar.start + i;
                const actualTableIndex = projectStartIndex + colIndex; // ตำแหน่งจริงในตาราง
                const isLastCell = i === bar.length - 1;
                cells.push(
                    <TableCell
                        key={`bar-${colIndex}`}
                        sx={{
                            padding: 0,
                            borderLeft: actualTableIndex >= exactEndPosition ? "1px solid #DDE1EB" : "none",
                        }}
                    >
                        <Box
                            sx={{
                                my: 2,
                                width: isLastCell ? `${percentOfMonth}%` : "100%",
                                backgroundColor: new Date() < new Date(list_data?.edpex_project_end_date) ? "#0F9F0C" : "#E80000",
                                ...(i === 0
                                    ? { borderRadius: "14px 0px 0px 14px" }
                                    : isLastCell
                                        ? { borderRadius: percentOfMonth > 50 ? "0px 14px 14px 0px" : "0px 40px 40px 0px" }
                                        : {}),
                            }}
                            className="h-[24px]"
                        />
                    </TableCell>
                );
            }
            currentIndex = bar.start + bar.length;
        }

        // ช่องว่างหลังแถบสุดท้าย (ลดลงตามจำนวนที่เพิ่มด้านหน้า)
        const remainingCells = totalMonths - projectStartIndex; // ลดจำนวนช่องตามที่เพิ่มด้านหน้า
        if (currentIndex < remainingCells) {
            for (let i = currentIndex; i < remainingCells; i++) {
                const actualTableIndex = projectStartIndex + i; // ตำแหน่งจริงในตาราง
                cells.push(
                    <TableCell
                        key={`gap-end-${i}`}
                        sx={{
                            borderLeft: actualTableIndex >= endMonthIndex ? "1px solid #DDE1EB" : "none",
                            padding: 0,
                        }}
                    />
                );
            }
        }
        return cells;
    }


    const TableCellRowCustom = styled(TableCell)({
        border: '1px solid #555',
    })
    const renderRows = (list: any, key: string, index_val: number) => {

        return (
            <React.Fragment key={key}>
                <TableCellRowCustom rowSpan={2} >
                    <div className='w-full flex flex-col'>
                        <span>
                            <Typography>
                                {list?.edpex_standard_point_name || "-"}
                            </Typography>
                        </span>
                        <span onClick={() => setOpenDetail((prev) => ({ ...prev, id: list?.id, status: true }))}>
                            <Button onClick={() => {
                                setPageDetail(index_val + 1);
                                handleFindDetailProject(list?.id_edpex_project);
                            }} startIcon={<IconComponent.OpenIcon />} sx={{ gap: 2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                <Typography>OPEN</Typography>
                            </Button>
                        </span>
                    </div>
                </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}> {list?.edpex_standard_point_detail_name || "-"}   </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}>  {list?.edpex_mission_name || "-"}    </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}> {list?.edpex_project_name || "-"} </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}> {Number(list?.edpex_project_budget || 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })} </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}> {list?.edpex_project_division_responsible || "-"} </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}> {list?.edpex_project_user_responsible || "-"} </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}> {list?.edpex_project_department_responsible || "-"} </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}> {list?.edpex_standard_point_detail_name || "-"} </TableCellRowCustom>
                <TableCellRowCustom sx={{ p: 0 }} rowSpan={2}>
                    <Table size="small" sx={{ width: '100%' }}>
                        <TableBody sx={{ placeItems: 'center' }}>
                            {list?.edpex_project_indicators?.map((ip: any, index: number) => (
                                <TableRow key={index}>
                                    <TableCell
                                        sx={{
                                            minHeight: '40px',      // บังคับให้ cell มีความสูงพอ
                                            borderBottom: index === [...list?.edpex_project_indicators]?.length - 1 ? 'none' : '2px solid #DDE1EB',
                                            whiteSpace: 'nowrap',
                                            padding: '4px 8px',
                                            textAlign: 'center',         // จัดแนวนอน
                                            verticalAlign: 'middle'      // จัดแนวตั้ง
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',     // แนวตั้ง
                                                justifyContent: 'center', // แนวนอน
                                                height: '100%',
                                                minHeight: '40px'         // บังคับให้ cell มีความสูงพอ
                                            }}
                                        >
                                            {ip?.edpex_project_indicators || "-"}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableCellRowCustom>
                <TableCellRowCustom sx={{ p: 0 }} rowSpan={2}>
                    <Table size="small" sx={{ width: '100%' }}>
                        <TableBody>
                            {list?.edpex_project_indicators?.map((ip: any, index: number) => (
                                <TableRow key={index}>
                                    <TableCell
                                        sx={{
                                            minHeight: '40px',
                                            borderBottom: index === [...list?.edpex_project_indicators]?.length - 1 ? 'none' : '2px solid #DDE1EB',
                                            whiteSpace: 'nowrap',
                                            padding: '4px 8px',
                                            textAlign: 'center',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%',
                                                minHeight: '40px'
                                            }}
                                        >
                                            {ip?.edpex_project_indicators_point || "-"}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableCellRowCustom>
                <TableCellRowCustom sx={{ p: 0 }} rowSpan={2}>
                    <Table size="small" sx={{ width: '100%' }}>
                        <TableBody>
                            {list?.edpex_project_indicators?.map((ip: any, index: number) => (
                                <TableRow key={index}>
                                    <TableCell
                                        sx={{
                                            minHeight: '40px',
                                            borderBottom: index === [...list?.edpex_project_indicators]?.length - 1 ? 'none' : '2px solid #DDE1EB',
                                            whiteSpace: 'nowrap',
                                            padding: '4px 8px',
                                            textAlign: 'center',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%',
                                                minHeight: '40px'
                                            }}
                                        >
                                            {ip?.edpex_project_indicators_target_point || "-"}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}> {list?.edpex_project_target_group || "-"} </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}> {list?.edpex_project_result || "-"} </TableCellRowCustom>
                <TableCellRowCustom rowSpan={2}>
                    <Typography textAlign={'center'}>
                        {list?.fiscal_year ? Number(list?.fiscal_year) + 543 : "-"}
                    </Typography>
                </TableCellRowCustom>
            </React.Fragment>
        )
    }
    const renderRowsNext = (list: any, key: string) => {
        return (
            <React.Fragment key={key}>
                <TableCellRowCustom sx={{ minWidth: 320 }} rowSpan={2} >
                    <div className='flex flex-col gap-4'>
                        {list?.edpex_project_responsibles?.map((list: any, i: number) => {
                            const full_name = list?.edpex_responsible?.first_name + " " + list?.edpex_responsible?.last_name
                            return (
                                <span key={i} className='flex flex-col'>
                                    <Typography fontWeight={600}>{full_name || "-"}</Typography>
                                    <div className='text-[#828282]'>{i === 0 ? 'ผู้รับผิดชอบหลัก' : 'ผู้รับผิดชอบร่วม'}</div>
                                </span>
                            )
                        })}
                    </div>
                </TableCellRowCustom>
                <TableCellRowCustom sx={{
                    minWidth: 120
                }} rowSpan={2} >{list?.edpex_project_remark || "-"} </TableCellRowCustom>
                <TableCellRowCustom sx={{
                    minWidth: 240
                }} rowSpan={2} >{
                        <StatusCustom
                            sx={{ maxWidth: 'fit-content' }}
                            text={ed_pex_project_status_data?.find((x) => x.value === list?.edpex_project_status)?.label || "-"}
                            type={ed_pex_project_status_data?.find((x) => x.value === list?.edpex_project_status)?.label || "-"}
                        />
                    } </TableCellRowCustom>
            </React.Fragment>
        )
    }


    const RenderTableBody = () => {
        return (
            <TableBody>
                {data?.length > 0 ? data?.map((list, index_data) => {
                    return (
                        <>
                            <TableRow>
                                {renderRows(list, `key-${index_data + 1}`, index_data)}
                                {renderBarCells(12, [{
                                    length: moment().add(1, 'month').diff(list?.edpex_project_start_date, 'months'),
                                    start: 0,
                                    active: list.accept
                                }], list?.edpex_project_end_date, list)}
                                {renderRowsNext(list, `key-${index_data + 1}`)}
                            </TableRow>
                            <TableRow >
                                {list?.graph_data?.flatMap((group: any, groupIndex: number) =>
                                    group.months.map((month: any, monthIndex: number) => {
                                        return (
                                            <TableCell
                                                key={`${group.year}-${month}-${groupIndex}-${monthIndex}`}
                                                align="center"
                                                sx={{
                                                    border: '1px solid #555',
                                                }}
                                            >
                                                {month}
                                            </TableCell>
                                        );
                                    })
                                )}

                            </TableRow>
                        </>
                    )
                }) : (
                    <TableRow>
                        <TableCell>
                            ไม่พบข้อมูล
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
        )
    }

    return (
        <ContainerLayout
            title='หน้าแสดงผล'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "a",
                            name: "ระบบ Edpex",
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: "edpexResultDisplay",
                            name: "หน้าแสดงผล",
                            pathName: routeName.cms.edpexResultDisplay,
                        },
                    ]}
                />
            }
            buttonContent={
                <div className='flex justify-end items-center gap-4'>
                    <span>
                        <ContainerButton
                            buttonData={[
                                {
                                    seq: 1,
                                    key: "DOWNLOAD_CSV",
                                    label: "ดาวน์โหลด Excel",
                                    type: "DOWNLOAD_CSV",
                                    buttonProps: {
                                        onClick: () => handleExportReportData()
                                    }
                                }
                            ]}
                        />
                    </span>
                    <span className='flex gap-4 justify-center items-center'>
                        <IconButton onClick={() => setStep(0)} sx={{
                            opacity: step === 0 ? '1' : '.5',
                        }}>
                            <QueryStatsOutlinedIcon />
                        </IconButton>
                        |
                        <IconButton onClick={() => setStep(1)} sx={{
                            opacity: step === 1 ? '1' : '.5',
                        }}>
                            <SpaceDashboardOutlinedIcon />
                        </IconButton>
                    </span>
                </div>
            }
            content={
                <>
                    {step === 0 && (
                        <main className='flex gap-4 w-full flex-col'>
                            <div className='flex gap-4 w-full'>
                                <section className='w-full max-w-[140px]'>
                                    <BoxColorCustom>
                                        <IconButton>
                                            <IconComponent.CountFile />
                                        </IconButton>
                                        <Typography fontSize={24} fontWeight={700}>
                                            {filterData.project_count || 0}
                                        </Typography>
                                        <Typography>
                                            จำนวนโครงการ
                                        </Typography>
                                    </BoxColorCustom>
                                </section>
                                <section className='w-full'>
                                    <StateComponents
                                        otherProps={{ spacing: 4 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12,
                                                    md: 4
                                                },
                                                fieldProps: {
                                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                                    startAdornment: <SearchIcon />,
                                                    placeholder: 'ค้นหาชื่อ - นามสกุล, เลขประจำตัวเจ้าหน้าที่, ตัวชี้วัด'
                                                }
                                            },
                                            {
                                                seq: 2,
                                                type: "AUTO-COMPLETE",
                                                gridProps: {
                                                    xs: 12,
                                                    md: 4
                                                },
                                                fieldProps: {
                                                    getOptionLabel: (op) => op,
                                                    labelId: "start_year",
                                                    onChange: (_, val) => {
                                                        set_end_year(null);
                                                        set_start_year(val);
                                                    },
                                                    placeholder: 'ปีงบประมาณเริ่มต้น',
                                                    options: year_data || [],
                                                    value: year_data?.find((x) => x === start_year) || null
                                                }
                                            },
                                            {
                                                seq: 3,
                                                type: "AUTO-COMPLETE",
                                                gridProps: {
                                                    xs: 12,
                                                    md: 4
                                                },
                                                fieldProps: {
                                                    getOptionLabel: (op) => op,
                                                    labelId: "end_year",
                                                    disabled: !start_year,
                                                    placeholder: 'ปีงบประมาณสิ้นสุด',
                                                    getOptionDisabled: (op: any) => start_year ? op < start_year : false,
                                                    onChange: (_, val) => set_end_year(val),
                                                    options: year_data || [],
                                                    value: year_data?.find((x) => x === end_year) || null
                                                }
                                            },
                                            {
                                                seq: 4,
                                                type: "AUTO-COMPLETE",
                                                gridProps: {
                                                    xs: 12,
                                                    md: 5
                                                },
                                                fieldProps: {
                                                    getOptionLabel: (op) => op?.label,
                                                    labelId: "ed_pex_department_responsible",
                                                    placeholder: "ทุกส่วนงานที่รับผิดชอบ",
                                                    onChange: (_, val) => {
                                                        set_department_responsible(val?.value);
                                                    },
                                                    options: ed_pex_department_responsible || [],
                                                    value: ed_pex_department_responsible?.find((x) => x.value === department_responsible) || null
                                                }
                                            },
                                            {
                                                seq: 5,
                                                type: "AUTO-COMPLETE",
                                                gridProps: {
                                                    xs: 12,
                                                    md: 5
                                                },
                                                fieldProps: {
                                                    placeholder: 'ทุกสถานะ',
                                                    getOptionLabel: (op) => op?.label,
                                                    labelId: "ed_pex_status",
                                                    onChange: (_, val) => set_ed_pex_status(val?.value),
                                                    options: ed_pex_project_status_data,
                                                    value: ed_pex_project_status_data?.find((x) => x.value === ed_pex_status) || null
                                                }
                                            },
                                            {
                                                seq: 6,
                                                type: "BUTTON",
                                                gridProps: {
                                                    xs: 12,
                                                    md: 2
                                                },
                                                fieldProps: {
                                                    buttonData: [
                                                        {
                                                            key: "SEARCH",
                                                            label: "ค้นหา",
                                                            fullWidth: true,
                                                            startIcon: <SearchIcon sx={{ color: 'white' }} />,
                                                            buttonProps: {
                                                                onClick: () => handleGetDataMini({
                                                                    end_year: end_year ? String(end_year) : undefined,
                                                                    keyword: search,
                                                                    edpex_project_status: ed_pex_status,
                                                                    start_year: start_year ? String(start_year) : undefined,
                                                                    edpex_project_division_responsible: department_responsible ? department_responsible : undefined
                                                                })
                                                            },
                                                            seq: 1,
                                                            type: "CONFIRM"
                                                        }
                                                    ]
                                                }
                                            },
                                        ]}
                                    />
                                </section>
                            </div>



                            {/* CONTENT */}

                            <section className='grid grid-cols-12 mt-10 gap-4'>
                                <article className='col-span-12 md:col-span-4'>
                                    <BoxContentRendering
                                        heading='พันธกิจ'
                                        data={filterData.dashboard_mission?.map((list) => {
                                            return {
                                                id: list?.id_edpex_mission,
                                                name: list?.edpex_mission_name || "ไม่ระบุ",
                                                qty: list?.count_val ? +list?.count_val : 0,
                                            }
                                        })}
                                        onCheckAll={(id) => {
                                            setFilterId((prev) => ({ ...prev, dashboard_mission: id }))
                                        }}
                                        check_data={filterId.dashboard_mission}
                                        onCheckData={(val) => {
                                            console.log(val, 'val')
                                            const has_id = filterId.dashboard_mission.includes(val?.id);
                                            if (has_id) {
                                                setFilterId((prev) => ({ ...prev, dashboard_mission: prev?.dashboard_mission.filter((x) => x !== val?.id) }))
                                            } else {
                                                setFilterId((prev) => ({ ...prev, dashboard_mission: [...prev.dashboard_mission, val?.id] }))
                                            }
                                        }}
                                    />
                                </article>
                                <article className='col-span-12 md:col-span-4'>
                                    <BoxContentRendering
                                        heading='รองผอ.ผู้รับผิดชอบ'
                                        data={filterData?.dashboard_department?.map((list) => {
                                            return {
                                                id: list.edpex_project_department_responsible,
                                                name: list.edpex_project_department_responsible || "ไม่ระบุ",
                                                qty: list.count_val ? +list?.count_val : 0
                                            }
                                        })}
                                        onCheckAll={(id) => {
                                            setFilterId((prev) => ({ ...prev, dashboard_department: id }))
                                        }}
                                        check_data={filterId.dashboard_department}
                                        onCheckData={(val) => {
                                            const has_id = filterId.dashboard_department.includes(val?.id);
                                            if (has_id) {
                                                setFilterId((prev) => ({ ...prev, dashboard_department: prev?.dashboard_department.filter((x) => x !== val?.id) }))
                                            } else {
                                                setFilterId((prev) => ({ ...prev, dashboard_department: [...prev.dashboard_department, val?.id] }))
                                            }
                                        }}
                                    />
                                </article>
                                <article className='col-span-12 md:col-span-4'>
                                    <BoxContentRendering
                                        heading='ข้อมูลงบประมาณ'
                                        date={new Date()}
                                        custom_component={
                                            <div className='flex gap-5 flex-wrap mt-5'>
                                                {[
                                                    {
                                                        name: "งบที่ตั้งไว้",
                                                        color: "#E3FBFF",
                                                        icon: <IconComponent.BudgetAllIcon />,
                                                        budget: formatBudget(filterData.dashboard_budget?.edpex_project_budget_all ? +filterData.dashboard_budget?.edpex_project_budget_all : 0)
                                                    },
                                                    {
                                                        name: "ใช้ไปแล้ว",
                                                        color: "#FFF4DE",
                                                        icon: <IconComponent.UsedIcon />,
                                                        budget: formatBudget(filterData.dashboard_budget?.edpex_project_budget_use ? +filterData.dashboard_budget?.edpex_project_budget_use : 0)
                                                    },
                                                    {
                                                        name: "งบคงเหลือ",
                                                        color: "#DCFCE7",
                                                        icon: <IconComponent.BalanceIcon />,
                                                        budget: formatBudget(filterData.dashboard_budget?.edpex_project_budget_balance ? +filterData.dashboard_budget?.edpex_project_budget_balance : 0)
                                                    }].map((list) => {
                                                        return (
                                                            <BoxColorCustom bgcolor={list.color} key={list.name}>
                                                                <IconButton>
                                                                    {list.icon}
                                                                </IconButton>
                                                                <Typography fontSize={24} fontWeight={700}>
                                                                    {list.budget || 0}
                                                                </Typography>
                                                                <Typography>
                                                                    {list.name}
                                                                </Typography>
                                                            </BoxColorCustom>
                                                        )
                                                    })}
                                            </div>
                                        }
                                        data={[]}
                                    />
                                </article>

                                <article className='col-span-12 md:col-span-4'>
                                    <BoxContentRendering
                                        heading='ไตรมาส'
                                        height={800}
                                        data={filterData?.dashboard_quarter?.map((list) => {
                                            return {
                                                id: list?.edpex_quarter,
                                                name: list?.edpex_quarter || "ไม่ระบุ",
                                                qty: list?.count_val ? +list?.count_val : 0
                                            }
                                        })}
                                        onCheckAll={(id) => {
                                            setFilterId((prev) => ({ ...prev, dashboard_quarter: id }))
                                        }}
                                        check_data={filterId.dashboard_quarter}
                                        onCheckData={(val) => {
                                            const has_id = filterId.dashboard_quarter.includes(val?.id);
                                            if (has_id) {
                                                setFilterId((prev) => ({ ...prev, dashboard_quarter: prev?.dashboard_quarter.filter((x) => x !== val?.id) }))
                                            } else {
                                                setFilterId((prev) => ({ ...prev, dashboard_quarter: [...prev.dashboard_quarter, val?.id] }))
                                            }
                                        }}
                                    />
                                </article>
                                <article className='col-span-12 md:col-span-4 flex gap-4 flex-col'>
                                    <span>
                                        <BoxContentRendering
                                            heading='สำนักงานที่รับผิดชอบ'
                                            height={250}
                                            data={filterData?.dashboard_deputy_director_responsible?.map((list, i) => {
                                                return {
                                                    id: list?.edpex_project_user_responsible,
                                                    name: list?.edpex_project_user_responsible || "ไม่ระบุ",
                                                    qty: list?.count_val ? +list?.count_val : 0
                                                }
                                            })}
                                            onCheckAll={(id) => {
                                                setFilterId((prev) => ({ ...prev, dashboard_deputy_director_responsible: id }))
                                            }}
                                            check_data={filterId.dashboard_deputy_director_responsible}
                                            onCheckData={(val) => {
                                                const has_id = filterId.dashboard_deputy_director_responsible.includes(val?.id);
                                                if (has_id) {
                                                    setFilterId((prev) => ({ ...prev, dashboard_deputy_director_responsible: prev?.dashboard_deputy_director_responsible.filter((x) => x !== val?.id) }))
                                                } else {
                                                    setFilterId((prev) => ({ ...prev, dashboard_deputy_director_responsible: [...prev.dashboard_deputy_director_responsible, val?.id] }))
                                                }
                                            }}
                                        />
                                    </span>
                                    <span>
                                        {filterData.dashboard_project_status?.length > 0 && (
                                            <BoxContentRendering
                                                disabled_heading
                                                heading=''
                                                heading_center='สถานะดำเนินการการดำเนินการของโครงการ'
                                                data={[]}
                                                height={530}
                                                disabled_scroll
                                                custom_component={
                                                    <PieChart
                                                        innerSize='50%'
                                                        data={filterData?.dashboard_project_status || []}
                                                    // data={[
                                                    //     {
                                                    //         y: filterData?.dashboard_project_status?.find((x) => x.edpex_project_status === EDPEX_PROJECT_STATUS.PENDING_PROCESS)?.count_val || 0,
                                                    //         name: "รอดำเนินการ",
                                                    //         color: "#FFC772",
                                                    //     },
                                                    //     {
                                                    //         y: filterData?.dashboard_project_status?.find((x) => x.edpex_project_status === EDPEX_PROJECT_STATUS.PROCESS)?.count_val || 0,
                                                    //         name: "กำลังดำเนินการ",
                                                    //         color: "#94CFF9",
                                                    //     },
                                                    //     {
                                                    //         y: filterData?.dashboard_project_status?.find((x) => x.edpex_project_status === EDPEX_PROJECT_STATUS.COMPLETED)?.count_val || 0,
                                                    //         name: "ดำเนินการเสร็จสิ้น",
                                                    //         color: "#5FB95D",
                                                    //     },
                                                    //     {
                                                    //         y: filterData?.dashboard_project_status?.find((x) => x.edpex_project_status === EDPEX_PROJECT_STATUS.OVERDUE)?.count_val || 0,
                                                    //         name: "เกินกำหนดระยะเวลา",
                                                    //         color: "#FF8D8D",
                                                    //     },
                                                    // ]}
                                                    />
                                                }
                                            />
                                        )}
                                    </span>
                                </article>
                                <article className='col-span-12 md:col-span-4'>
                                    <BoxContentRendering
                                        heading='ไตรมาส'
                                        height={800}
                                        data={[]}
                                        disabled_heading
                                        heading_center='ข้อมูลงบประมาณ'
                                        textAlignHeading='left'
                                        custom_component={
                                            <>
                                                <HorizontalChart
                                                    categories={[]}
                                                    data={[]}
                                                    series={[
                                                        {
                                                            type: "column",
                                                            color: "#3BC7DF",
                                                            data: filterData.dashboard_budget_mission?.edpex_project_budget_all,
                                                            name: "งบที่ตั้งไว้"
                                                        },
                                                        {
                                                            type: "column",
                                                            color: "#FF947A",
                                                            data: filterData.dashboard_budget_mission?.edpex_project_budget_use,
                                                            name: "ใช้ไปแล้ว"
                                                        },
                                                        {
                                                            type: "column",
                                                            color: "#49AF47",
                                                            data: filterData.dashboard_budget_mission?.edpex_project_budget_balance,
                                                            name: "งบคงเหลือ"
                                                        },
                                                    ]}
                                                    column
                                                />
                                                <div className='grid grid-cols-12 gap-4 mt-4'>
                                                    {filterData.dashboard_budget_mission?.edpex_mission_data?.map((list, i) => {
                                                        return (
                                                            <span key={i + 1} className='col-span-12'>
                                                                <Typography sx={{ opacity: list?.edpex_mission_name ? 1 : .5 }} fontSize={20}>
                                                                    {list?.edpex_mission_name || "ไม่ระบุ"}
                                                                </Typography>
                                                            </span>
                                                        )
                                                    })}
                                                </div>
                                            </>
                                        }
                                    />
                                </article>
                            </section>


                            {/* TABLE */}
                            <section className='grid grid-cols-12 gap-4 mt-8'>
                                <article className='col-span-12'>
                                    <TableCustom
                                        tableMinWidth={1920}
                                        tableFixedWidth
                                        customScroll
                                        page={page}
                                        pageLimit={pageLimit}
                                        sortBy={sortBy}
                                        sortType={sortType}
                                        headCells={headCells}
                                        rowCount={totalItems}
                                        rowsData={dataMini?.map((data: any, i: any) => {
                                            return renderData(data, i)
                                        })}
                                        onSort={handleRequestSort}
                                        setPageLimit={(value: number) => setPageLimit(value)}
                                        setPage={(value: number) => setPage(value)}
                                    />
                                </article>
                            </section>
                        </main>
                    )}



                    {step === 1 && (
                        <main className='w-full grid grid-cols-12 gap-6'>
                            <section className='col-span-12'>
                                <StateComponents
                                    otherProps={{ spacing: 3 }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            fieldProps: {
                                                onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearchEdPex }),
                                                startAdornment: <SearchIcon />,
                                                placeholder: 'ค้นหาโครงการ/กิจกรรม/งานที่รับผิดชอบ'
                                            }
                                        },
                                        {
                                            seq: 2,
                                            type: "AUTO-COMPLETE",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            fieldProps: {
                                                getOptionLabel: (op) => `${Number(op + 543)}`,
                                                labelId: "start_year_ed_pex",
                                                onChange: (_, val) => set_start_year_ed_pex(val),
                                                placeholder: 'ปีงบประมาณ',
                                                options: year_data || [],
                                                value: year_data?.find((x) => x === start_year_ed_pex) || null
                                            }
                                        },
                                        // {
                                        //     seq: 3,
                                        //     type: "AUTO-COMPLETE",
                                        //     gridProps: {
                                        //         xs: 12,
                                        //         md: 4
                                        //     },
                                        //     fieldProps: {
                                        //         getOptionLabel: (op) => op,
                                        //         labelId: "",
                                        //         placeholder: 'ปีงบประมาณสิ้นสุด',
                                        //         onChange: () => { },
                                        //         options: year_data || [],
                                        //         value: null
                                        //     }
                                        // },
                                        {
                                            seq: 4,
                                            type: "AUTO-COMPLETE",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            fieldProps: {
                                                getOptionLabel: (op) => op?.edpex_standard_point_name,
                                                labelId: "id_edpex_standard_point",
                                                placeholder: 'ทุกเกณฑ์ Edpex',
                                                onChange: (_, val) => set_id_edpex_standard_point(val?.id_edpex_standard_point || null),
                                                options: standard_point_data || [],
                                                value: standard_point_data?.find((x) => x?.id_edpex_standard_point === id_edpex_standard_point) || null
                                            }
                                        },
                                        {
                                            seq: 5,
                                            type: "AUTO-COMPLETE",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            fieldProps: {
                                                getOptionLabel: (op) => op?.label,
                                                labelId: "department_responsible_ed_pex",
                                                placeholder: 'ทุกส่วนงานที่รับผิดชอบ',
                                                onChange: (_, val) => set_department_responsible_ed_pex(val?.value),
                                                options: ed_pex_department_responsible || [],
                                                value: ed_pex_department_responsible?.find((x) => x.value === department_responsible_ed_pex) || null
                                            }
                                        },
                                        {
                                            seq: 6,
                                            type: "AUTO-COMPLETE",
                                            gridProps: {
                                                xs: 12,
                                                md: 4
                                            },
                                            fieldProps: {
                                                getOptionLabel: (op) => op?.label,
                                                labelId: "v",
                                                placeholder: 'ทุกสถานะ',
                                                onChange: (_, val) => {
                                                    set_status_ed_pex_data(val?.value);
                                                },
                                                options: ed_pex_project_status_data || [],
                                                value: ed_pex_project_status_data?.find((x) => x.value === status_ed_pex_data) || null,
                                            }
                                        },
                                    ]}
                                />
                            </section>
                            <section className='col-span-12'>
                                <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                                    <Table size='medium' sx={{
                                        minWidth: 4450,
                                        // tableLayout: 'fixed'
                                    }} aria-label="thai table">
                                        <TableHead>
                                            <TableRow>
                                                {headCellAll.map((hdl) => {
                                                    return (
                                                        <TableCell sx={{
                                                            backgroundColor: '#333',
                                                            color: 'white',
                                                            minWidth: hdl.width,
                                                            border: '1px solid white',
                                                            textAlign: 'center'
                                                        }} rowSpan={2}>
                                                            {hdl.label}
                                                        </TableCell>
                                                    )
                                                })}
                                                <TableCell
                                                    align="center"
                                                    colSpan={12}
                                                    sx={{
                                                        backgroundColor: '#444',
                                                        color: 'white',
                                                    }}
                                                >
                                                    เดือน
                                                    {/* {group.year} */}
                                                </TableCell>
                                                {headCellAllNext.map((hdl) => {
                                                    return (
                                                        <TableCell sx={{
                                                            backgroundColor: '#333',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            textAlign: 'center'
                                                        }} rowSpan={2}>
                                                            {hdl.label}
                                                        </TableCell>
                                                    )
                                                })}
                                            </TableRow>
                                            {/* แถวที่ 2: เดือน */}
                                            <TableRow>
                                                {groupedMonths.flatMap(group =>
                                                    group.months.map(month => (
                                                        <TableCell
                                                            key={`${group.year}-${month.key}`}
                                                            align="center"
                                                            sx={{
                                                                backgroundColor: '#333',
                                                                color: 'white',
                                                                border: '1px solid white'
                                                            }}
                                                        >
                                                            {month.month}
                                                        </TableCell>
                                                    ))
                                                )}
                                            </TableRow>
                                        </TableHead>
                                        {RenderTableBody()}
                                    </Table>
                                </TableContainer>
                                <CustomPagination
                                    page={pageEdPex}
                                    pageLimit={pageLimitEdPex}
                                    setPage={(p) => setPageEdPex(p)}
                                    setPageLimit={(pl) => setPageLimitEdPex(pl)}
                                    totalItems={totalItemsEdPex}
                                />
                            </section>
                        </main>
                    )}

                    <Drawer
                        anchor={'right'}
                        open={openDetail.status}
                        onClose={() => {
                            setOpenDetail({ id: null, status: false, full_width: false });
                        }}
                        sx={{
                            transition: "all .5s ease"
                        }}
                        PaperProps={{
                            className: openDetail.full_width ? 'w-full' : undefined,
                            sx: {
                                transition: "all .5s ease"
                            }
                        }}
                    >
                        <div className={`w-full min-w-[50vw] p-3 md:p-[40px]`}>
                            <span className='flex justify-start'>
                                <IconButton onClick={() => setOpenDetail({ full_width: false, id: null, status: false })}>
                                    <KeyboardDoubleArrowRightIcon />
                                </IconButton>
                                <IconButton onClick={() => setOpenDetail((prev) => ({ ...prev, full_width: !prev.full_width }))}>
                                    <OpenInFullIcon sx={{ rotate: '90deg' }} />
                                </IconButton>
                            </span>

                            <section className='w-full mt-4 grid grid-cols-12'>
                                <article className='col-span-12'>
                                    <Typography variant='h5'>
                                        {detailProject?.edpex_project_name || "-"}
                                    </Typography>
                                </article>
                                <article className='grid grid-cols-12 col-span-12 mt-4 gap-4'>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            เกณฑ์ Edpex
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            {standard_point_data?.find((x) => x?.id_edpex_standard_point === detailProject?.id_edpex_standard_point)?.edpex_standard_point_name || "-"}
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            เกณฑ์คะแนน
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            {detailProject?.edpex_standard_point_detail?.edpex_standard_point_detail_name || "-"}
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            พันธกิจ
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            {detailProject?.edpex_mission?.edpex_mission_name || "-"}
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            งมประมาณ
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            {Number(detailProject?.edpex_project_budget ? detailProject?.edpex_project_budget : 0).toLocaleString(undefined, {
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            })}
                                        </Typography>
                                    </div>
                                    {/* <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            ส่วนงานที่รับผิดชอบ
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            วิชาการ
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            การดำเนินการ
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            เพื่อพัฒนางานวิจัยและพุทธนวัตกรรมให้สามารถ ตอบโจทย์ความความต้องการ
                                            ของชุมชนและสังคม ด้านสติ ปัญญา และคุณธรรม
                                        </Typography>
                                    </div> */}
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            ส่วนงานที่รับผิดชอบ
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            {detailProject?.edpex_project_division_responsible || "-"}
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            การดำเนินการ
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            เพื่อพัฒนางานวิจัยและพุทธนวัตกรรมให้สามารถ ตอบโจทย์ความความต้องการของชุมชน และสังคมด้านสติ
                                            ปัญญา และคุณธรรม
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            ตัวชี้วัด
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-8'>
                                        {detailProject?.edpex_project_indicators?.map((list: any) => {
                                            return (
                                                <Typography key={list}>
                                                    {list?.edpex_project_indicators || "-"}
                                                </Typography>
                                            )
                                        })}
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            กลุ่มเป้าหมาย
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            {detailProject?.edpex_project_target_group || "-"}
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            ผลลัพธ์ EdPEx
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            {detailProject?.edpex_project_result || "-"}
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            ประวัติการใช้เงิน
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            -
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            ผู้เกี่ยวข้อง
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        {detailProject?.edpex_project_responsible?.map((list: any) => {
                                            return (
                                                <Typography>
                                                    {list?.name || "-"}
                                                </Typography>
                                            )
                                        })}
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            หมายเหตุ
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <Typography>
                                            -
                                        </Typography>
                                    </div>
                                    <div className='col-span-6 md:col-span-3'>
                                        <Typography>
                                            สถานะ
                                        </Typography>
                                    </div>
                                    <div className='col-span-12 md:col-span-9'>
                                        <span className='flex justify-start'>
                                            <StatusCustom
                                                sx={{ maxWidth: 'fit-content' }}
                                                text={ed_pex_project_status_data?.find((x) => x.value === detailProject?.edpex_project_status)?.label || "-"}
                                                type={ed_pex_project_status_data?.find((x) => x.value === detailProject?.edpex_project_status)?.label || "-"}
                                            />
                                        </span>
                                    </div>
                                </article>

                                <article className='col-span-12 flex justify-center items-center mt-10'>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', padding: '10px' }}>
                                        <IconButton
                                            onClick={async () => {
                                                const firstId = data[0]?.id_edpex_project;
                                                if (firstId) {
                                                    setPageDetail(1);
                                                    await handleFindDetailProject(firstId);
                                                }
                                            }}
                                            disabled={pageDetail === 1}
                                            aria-label="back-all"
                                        >
                                            <KeyboardDoubleArrowLeftIcon />
                                        </IconButton>
                                        <IconButton
                                            onClick={async () => {
                                                const newPage = pageDetail - 1;
                                                const prevId = data[newPage - 1]?.id_edpex_project;
                                                if (newPage >= 1 && prevId) {
                                                    setPageDetail(newPage);
                                                    await handleFindDetailProject(prevId);
                                                }
                                            }}
                                            disabled={pageDetail === 1}
                                            aria-label="back"
                                        >
                                            <KeyboardArrowLeftIcon />
                                        </IconButton>
                                        <Typography>
                                            {`${pageDetail} จาก ${data?.length}`}
                                        </Typography>
                                        <IconButton
                                            onClick={async () => {
                                                const newPage = pageDetail + 1;
                                                const nextId = data[newPage - 1]?.id_edpex_project;
                                                if (newPage <= data.length && nextId) {
                                                    setPageDetail(newPage);
                                                    await handleFindDetailProject(nextId);
                                                }
                                            }}
                                            disabled={pageDetail === data.length}
                                            aria-label="forward"
                                        >
                                            <KeyboardArrowRightIcon />
                                        </IconButton>
                                        <IconButton
                                            onClick={async () => {
                                                const lastId = data[data.length - 1]?.id_edpex_project;
                                                if (lastId) {
                                                    setPageDetail(data.length);
                                                    await handleFindDetailProject(lastId);
                                                }
                                            }}
                                            disabled={pageDetail === data.length}
                                            aria-label="forward-all"
                                        >
                                            <KeyboardDoubleArrowRightIcon />
                                        </IconButton>
                                    </div>

                                    {/* <CustomPagination
                                        page={pageEdPex}
                                        pageLimit={pageLimitEdPex}
                                        setPage={(p) => setPageEdPex(p)}
                                        setPageLimit={(pl) => setPageLimitEdPex(pl)}
                                        totalItems={totalItemsEdPex}
                                        hidden_total
                                        sxContainer={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    /> */}
                                </article>
                            </section>
                        </div>
                    </Drawer>
                </>
            }
        />
    )
}

export default EdPexDisplayPage